export default "__VITE_ASSET__uZc7em63__"